module.exports = __webpack_public_path__ + "img/oman.5155addd.svg";